import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBalanceScale, faAddressBook, faBook, faBriefcase, faBuilding, faCalculator,
  faCalendar, faCheck, faCheckCircle, faClipboardCheck, faClipboard, faCloud,
  faCogs, faColumns, faCube, faEdit, faExchange, faFileInvoice, faFilePdf,
  faFileSignature, faFileText, faFilter, faFlag, faFolderOpen, faGavel,
  faHashtag, faHistory, faImage, faKey, faLink, faList, faListAlt, faListOl,
  faLock, faMapMarkerAlt, faPercent, faPlus, faReceipt, faSave, faShieldAlt,
  faSignIn, faSitemap, faSliders, faTags, faTimes, faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { createModuleExtensionHost } from "../../modules/extensions/createModuleExtensionHost";

const icons = {
  faBalanceScale, faAddressBook, faBook, faBriefcase, faBuilding, faCalculator,
  faCalendar, faCheck, faCheckCircle, faClipboardCheck, faClipboard, faCloud,
  faCogs, faColumns, faCube, faEdit, faExchange, faFileInvoice, faFilePdf,
  faFileSignature, faFileText, faFilter, faFlag, faFolderOpen, faGavel,
  faHashtag, faHistory, faImage, faKey, faLink, faList, faListAlt, faListOl,
  faLock, faMapMarkerAlt, faPercent, faPlus, faReceipt, faSave, faShieldAlt,
  faSignIn, faSitemap, faSliders, faTags, faTimes, faTrash,
};

export default createModuleExtensionHost({
  moduleKey: "factuflow",
  scriptUrl: "/factuflow/extensions/index.js",
  styleUrl: "/factuflow/extensions/index.css",
  sdk: { icons, fontawesome: { FontAwesomeIcon } },
});
